export default __webpack_public_path__ + "static/media/dashboard-default.a9e28995.jpg";